import React from 'react';
import { Card } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import BgImg from '../../assets/images/bg-organization.jpg';

const ValueCard = ({ number, title, icon: Icon, description }) => (
  <Card className="p-6 bg-white relative flex flex-col items-start h-[200px]">
    <div className="text-gray-400 absolute right-6 top-6 text-4xl font-bold">
      {number}
    </div>
    <div className="mb-4">
      <Icon className="w-12 h-12 text-gray-600" sx={{ fontSize: 36, color: '#589197' }} />
    </div>
    <div className="flex items-center justify-center h-8 md:h-20 text-base md:text-lg lg:text-xl font-bold mb-4 text-center">
      {title}
    </div>
    <div variant="body1" className="text-sm md:text-base lg:text-lg text-gray-700">
      {description}
    </div>
  </Card>
);

const OurVision = () => {
  const values = [
    {
      number: "01",
      title: "Harnessing Renewables",
      icon: RocketLaunchIcon,
      description: "Using Australia's abundant sunlight and water for clean fuel production."
    },
    {
      number: "02",
      title: "Affordable Solutions",
      icon: GroupsIcon,
      description: "Making green energy accessible globally."
    }
  ];

  return (
    <div className="relative py-16 px-6 sm:px-8 md:px-10 lg:px-20">
      {/* Background overlay for image */}
      <div className="absolute inset-0 bg-black/50">
        <img src={BgImg} alt="Duralyze Hydrogen" className="w-full h-full object-cover" />
        {/* Mask */}
        <div className="absolute top-0 left-0 w-full h-full bg-white opacity-30"></div>
      </div>
      
      <div className="relative container mx-auto px-4">
        <div className="text-center mb-10 md:mb-16">
          <div className="text-theme-blue font-bold text-2xl md:text-3xl lg:text-4xl mb-2 md:mb-4">
            Our Vision
          </div>
          <div className="text-gray-700 font-bold text-xl md:text-2xl lg:text-3xl mb-2 md:mb-4">
            The Better Source of Energy for the 
            <span className="text-white mb-12 ml-2 font-bold">
                Better Tomorrow
            </span>
          </div>

          <div className='text-gray-700 text-left text-base md:text-xl lg:text-2xl'>
            To revolutionize energy systems by commercializing green molecules like hydrogen, ammonia, and methanol. We focus on:
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20">
          {values.map((value, index) => (
            <ValueCard
              key={index}
              number={value.number}
              title={value.title}
              icon={value.icon}
              description={value.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurVision;